import { ButtonsStore } from "./button"
import { CalendarsStore } from "./calendar"
import { ScheduleCalendarsStore } from "./scheduleCalendar"

export {
    CalendarStore, 
    CalendarsStore, 
    ECalendarType, 
    type ICalendarRool, 
    type ICalendarRoolTime, 
    type IWeeklyState, 
    type IExclude, 
    type ITime, 
    type IPeriod,
    type EWeek
} from './calendar'
export {
    ScheduleCalendarType,
} from "./scheduleCalendar"
export {ButtonsStore, ButtonStore} from './button'

export type IStore = {
    buttons: ButtonsStore
    calendars: CalendarsStore
}

export class Store implements IStore {
    buttons = new ButtonsStore()
    calendars = new CalendarsStore()
    scheduleCalendars = new ScheduleCalendarsStore();
}

export const RootStore = new Store()